 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLEBADFRONT from '@/components/xhtml/ebadfront'
 import XHTMLARCHIVE from '@/components/xhtml/archive'
 import ADVERTFRONTADD from '@/components/Advert/Front-add'
 import XHTML02_TITLE from '@/components/xhtml/02_Title'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_FM01 from '@/components/xhtml/05_Fm01'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML07_FOREWORD from '@/components/xhtml/07_Foreword'
 import XHTML08_PREFACE from '@/components/xhtml/08_Preface'
 import XHTML09_ACKNOWLEDGMENTS from '@/components/xhtml/09_Acknowledgments'
 import XHTML10_MAPS from '@/components/xhtml/10_Maps'
 import XHTML11_PART_ONE from '@/components/xhtml/11_Part_One'
 import XHTML12_CHAPTER01 from '@/components/xhtml/12_Chapter01'
 import XHTML13_CHAPTER02 from '@/components/xhtml/13_Chapter02'
 import XHTML14_CHAPTER03 from '@/components/xhtml/14_Chapter03'
 import XHTML15_CHAPTER04 from '@/components/xhtml/15_Chapter04'
 import XHTML16_CHAPTER05 from '@/components/xhtml/16_Chapter05'
 import XHTML17_CHAPTER06 from '@/components/xhtml/17_Chapter06'
 import XHTML18_CHAPTER07 from '@/components/xhtml/18_Chapter07'
 import XHTML19_PART_TWO from '@/components/xhtml/19_Part_Two'
 import XHTML20_CHAPTER08 from '@/components/xhtml/20_Chapter08'
 import XHTML21_CHAPTER09 from '@/components/xhtml/21_Chapter09'
 import XHTML22_CHAPTER10 from '@/components/xhtml/22_Chapter10'
 import XHTML23_CHAPTER11 from '@/components/xhtml/23_Chapter11'
 import XHTML24_CHAPTER12 from '@/components/xhtml/24_Chapter12'
 import XHTML25_CHAPTER13 from '@/components/xhtml/25_Chapter13'
 import XHTML26_PART_THREE from '@/components/xhtml/26_Part_Three'
 import XHTML27_CHAPTER14 from '@/components/xhtml/27_Chapter14'
 import XHTML28_CHAPTER15 from '@/components/xhtml/28_Chapter15'
 import XHTML29_CHAPTER16 from '@/components/xhtml/29_Chapter16'
 import ADVERTFRONTADD2 from '@/components/Advert/Front-add2'
 import XHTML30_ENDNOTES from '@/components/xhtml/30_Endnotes'
 import XHTML31_SELECTIVE_FURTHER_READING from '@/components/xhtml/31_Selective_Further_Reading'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTMLCASEMATE from '@/components/xhtml/casemate'
 import XHTMLORIMAD from '@/components/xhtml/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/07_Foreword",
 			"name" : "xhtml/07_Foreword",
 			"component" : XHTML07_FOREWORD
 		},
 		{
 			"path" : "/xhtml/08_Preface",
 			"name" : "xhtml/08_Preface",
 			"component" : XHTML08_PREFACE
 		},
 		{
 			"path" : "/xhtml/09_Acknowledgments",
 			"name" : "xhtml/09_Acknowledgments",
 			"component" : XHTML09_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/10_Maps",
 			"name" : "xhtml/10_Maps",
 			"component" : XHTML10_MAPS
 		},
 		{
 			"path" : "/xhtml/11_Part_One",
 			"name" : "xhtml/11_Part_One",
 			"component" : XHTML11_PART_ONE
 		},
 		{
 			"path" : "/xhtml/12_Chapter01",
 			"name" : "xhtml/12_Chapter01",
 			"component" : XHTML12_CHAPTER01
 		},
 		{
 			"path" : "/xhtml/13_Chapter02",
 			"name" : "xhtml/13_Chapter02",
 			"component" : XHTML13_CHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js